import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "message-circle-alt",
  "use": "message-circle-alt-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"message-circle-alt\"><path fill=\"none\" d=\"M15 7.611a6.518 6.518 0 0 1-.7 2.956 6.611 6.611 0 0 1-5.911 3.655 6.518 6.518 0 0 1-2.956-.7L1 15l1.478-4.433a6.518 6.518 0 0 1-.7-2.956A6.611 6.611 0 0 1 5.433 1.7 6.518 6.518 0 0 1 8.39 1h.389A6.596 6.596 0 0 1 15 7.222v.39z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol